import { httpRequest } from '@/utils/request';
import { CommonResponse, TableReponseType } from '@/types';

export interface DeviceProperty {
  type_spec?: any;
  value: number;
  time: number;
  code: string;
  data_type: string;
  unit: string;
  name: string;
  access_mode: 'RW' | 'R';
}

export function getDeviceProperty({
  id,
  page,
  pageSize,
  info,
  tag,
}: {
  id: string;
  page: number;
  pageSize: number;
  info?: string;
  tag?: string;
}) {
  const query = new URLSearchParams();
  query.set('last', 'true');
  query.set('page', String(page));
  query.set('pageSize', String(pageSize));
  if (info) query.set('info', info);
  if (tag) query.set('tag', tag);
  return httpRequest<any, CommonResponse<TableReponseType<DeviceProperty>>>({
    url: `/api/v1/device/${id}/thing-model/property?${query.toString()}`,
  });
}

export function getDevicePropertyCodeClassifications({ id }: { id: string }) {
  return httpRequest<any, CommonResponse<string[]>>({
    url: `/api/v1/device/${id}/thing-model/property/code-classifications`,
  });
}

export interface ReportDaum {
  value: number;
  time: number;
}

export interface HistoryProperty {
  list: ReportDaum[];
  code: string;
  data_type: string;
  unit: string;
  name: string;
  access_mode: string;
}

export function getHistoryProperty<T>(
  id: string,
  data: {
    code: string;
    start: number;
    end: number;
    page?: number;
    pageSize?: number;
    isAll?: boolean;
  },
) {
  return httpRequest<any, CommonResponse<T>>({
    url: `/api/v1/device/${id}/thing-model/history-property?code=${data.code}&range=${data.start}&range=${data.end}&page=${data.page}&pageSize=${data.pageSize}`,
  });
}

export function getHistoryPropertyAll<T>(
  id: string,
  data: {
    code: string;
    start: number;
    end: number;
  },
) {
  return httpRequest<any, CommonResponse<T>>({
    url: `/api/v1/device/${id}/thing-model/history-property?code=${data.code}&range=${data.start}&range=${data.end}&isAll=true`,
  });
}

export interface DeviceEventRequestType {
  id: string;
  eventCode: string;
  start: number;
  end: number;
  // eventType: 'info' | 'alert' | 'error' | ''
  page?: number;
  pageSize?: number;
}

export interface DeviceEvent {
  event_code: string;
  event_type: string;
  report_time: number;
  name: string;
  output_data: {
    Data: string;
    Data2: number;
  };
}

export function getDeviceEvent<T>({ id, eventCode, start, end, page, pageSize }: DeviceEventRequestType) {
  return httpRequest<any, CommonResponse<T>>({
    url: `/api/v1/device/${id}/thing-model/event?eventCode=${eventCode}&range=${start}&range=${end}&page=${page}&pageSize=${pageSize}`,
  });
}

export interface DeviceServiceRequestType {
  id: string;
  code: string;
  start: number;
  end: number;
  page?: number;
  pageSize?: number;
}

export interface DeviceService {
  report_time: number;
  code: string;
  service_name: string;
  input_data: {
    ForceDelete: number;
  };
  output_data: {
    code: number;
    message: string;
  };
}

export function getDeviceService<T>({ id, code, start, end, page, pageSize }: DeviceServiceRequestType) {
  return httpRequest<any, CommonResponse<T>>({
    url: `/api/v1/device/${id}/thing-model/service?code=${code}&range=${start}&range=${end}&page=${page}&pageSize=${pageSize}`,
  });
}

export function deviceControl(data: { deviceId: string; data: { [key: string]: boolean } }) {
  return httpRequest<any, CommonResponse<any>>({
    url: '/api/v1/device/control',
    method: 'post',
    data,
  });
}
